import {
  Dialog,
  DialogContent,
  makeStyles,
  IconButton,
} from '@material-ui/core'
import DoneIcon from '@material-ui/icons/Done'
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import CloseIcon from '@material-ui/icons/Close'
import InfoIcon from '@material-ui/icons/Info'
import ButtonSp from '../ui/ButtonSp'
import clsx from 'clsx'
import { useTranslation } from 'next-i18next'

const useStyles = makeStyles((theme) => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    padding: `${theme.spacing(7)}px ${theme.spacing(7)}px ${theme.spacing(
      7
    )}px ${theme.spacing(7)}px !important`,
    textAlign: 'center',
    [theme.breakpoints.down('xs')]: {
      padding: `${theme.spacing(2)}px ${theme.spacing(2)}px ${theme.spacing(
        2
      )}px ${theme.spacing(2)}px !important`,
    }
  },
  icon: {
    width: 80,
    height: 80,
  },
  greenIcon: {
    color: '#219653',
  },
  redIcon: {
    color: 'red',
  },
  closeButton: {
    position: 'absolute',
    top: theme.spacing(4),
    right: theme.spacing(4),
    [theme.breakpoints.down('xs')]: {
      top: theme.spacing(1),
      right: theme.spacing(1),
    },
  },
  title: {
    fontWeight: 500,
    fontSize: 22,
    color: '#404041',
    marginBottom: theme.spacing(3),
    ...theme.headerFont,
  },
  redTitle: {
    color: 'red',
  },
  subtitle: {
    fontWeight: 400,
    fontSize: 16,
    color: '#404041',
    marginTop: 0,
    marginBottom: theme.spacing(4),
    whiteSpace: 'pre-line',
  },
  noteBox: {
    display: 'flex',
    alignItems: 'flex-start',
    textAlign: 'left',
    backgroundColor: '#e8f0fe',
    border: '1px solid #aecbfa',
    borderRadius: theme.spacing(1),
    padding: `${theme.spacing(1.5)}px ${theme.spacing(2)}px`,
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('xs')]: {
      padding: `${theme.spacing(1)}px ${theme.spacing(1.5)}px`,
    },
  },
  noteIcon: {
    color: '#174ea6',
    fontSize: 20,
    marginTop: 1,
    marginRight: theme.spacing(1),
    flexShrink: 0,
  },
  noteText: {
    fontSize: 14,
    color: '#404041',
    whiteSpace: 'pre-line',
  },
  button: {
    ...theme.homeStyle.button,
  },
  redButton: {
    backgroundColor: 'red',
    color: '#FFFFFF',
  },
}))

const ApplyResultModal = ({
  isOpen,
  setOpen,
  title,
  subtitle,
  type = 'success',
  note,
}) => {
  const classes = useStyles()
  const { i18n } = useTranslation('common')
  const tTh = i18n.getFixedT('th', 'common')
  const isFail = type === 'fail'

  return (
    <Dialog onClose={() => setOpen(false)} open={isOpen} maxWidth="lg">
      <DialogContent className={classes.content}>
        <IconButton
          className={classes.closeButton}
          onClick={() => setOpen(false)}
        >
          <CloseIcon />
        </IconButton>
        {isFail ? (
          <HighlightOffIcon className={clsx(classes.icon, classes.redIcon)} />
        ) : (
          <DoneIcon className={clsx(classes.icon, classes.greenIcon)} />
        )}
        <h2 className={clsx(classes.title, isFail && classes.redTitle)}>
          {title}
        </h2>
        <h3 className={classes.subtitle}>{subtitle}</h3>
        {note && (
          <div className={classes.noteBox}>
            <InfoIcon className={classes.noteIcon} />
            <span className={classes.noteText}>{note}</span>
          </div>
        )}
        <ButtonSp
          className={clsx(classes.button, isFail && classes.redButton)}
          onClick={() => setOpen(false)}
        >
          {tTh('okay')}
        </ButtonSp>
      </DialogContent>
    </Dialog>
  )
}

export default ApplyResultModal
